import React from 'react'
import { useNavigate } from 'react-router-dom'
import { adminAPI } from '@/lib/api/admin'

interface AdminLayoutProps {
  children: React.ReactNode
  onLogout?: () => void
}

export default function AdminLayout({ children, onLogout }: AdminLayoutProps) {
  const navigate = useNavigate()

  const handleLogout = async () => {
    if (onLogout) {
      onLogout()
    } else {
      try {
        await adminAPI.logout()
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        navigate('/admin/login')
      }
    }
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--background-secondary)' }}>
      {/* Admin Navigation Header */}
      <header className="shadow-sm border-b" style={{ 
        backgroundColor: 'var(--surface-primary)', 
        borderColor: 'var(--border-primary)'
      }}>
        <div className="max-w-7xl mx-auto" style={{ padding: 'var(--spacing-md) var(--spacing-xl)' }}>
          <div className="flex items-center justify-between">
            {/* Logo and Admin Badge */}
            <div className="flex items-center" style={{ gap: 'var(--spacing-md)' }}>
              <div className="flex items-center" style={{ gap: 'var(--spacing-sm)' }}>
                <h1 className="text-xl font-bold" style={{ color: 'var(--text-primary)' }}>certi</h1>
                <span className="px-3 py-1 text-xs font-medium rounded-full" style={{
                  backgroundColor: 'var(--brand-primary)',
                  color: 'var(--text-inverse)'
                }}>
                  Admin
                </span>
              </div>
            </div>

            {/* Navigation Links */}
            <nav className="hidden md:flex items-center" style={{ gap: 'var(--spacing-xl)' }}>
              <button
                onClick={() => navigate('/admin/dashboard')}
                className="font-medium transition-colors duration-150 hover-text-primary"
                style={{ color: 'var(--text-secondary)' }}
              >
                Dashboard
              </button>
              <button
                onClick={() => navigate('/admin/analytics')}
                className="font-medium transition-colors duration-150 hover-text-primary"
                style={{ color: 'var(--text-secondary)' }}
              >
                Analytics
              </button>
              <button
                onClick={() => navigate('/admin/bulk-import')}
                className="font-medium transition-colors duration-150 hover-text-primary"
                style={{ color: 'var(--text-secondary)' }}
              >
                Bulk Import
              </button>
              <button
                onClick={() => navigate('/admin/fulfillment')}
                className="font-medium transition-colors duration-150 hover-text-primary"
                style={{ color: 'var(--text-secondary)' }}
              >
                Fulfillment
              </button>
              <button
                onClick={() => navigate('/marketplace')}
                className="font-medium transition-colors duration-150 hover-text-primary"
                style={{ color: 'var(--text-secondary)' }}
              >
                View Site
              </button>
            </nav>

            {/* User Actions */}
            <div className="flex items-center" style={{ gap: 'var(--spacing-md)' }}>
              <button
                onClick={handleLogout}
                className="flex items-center font-medium transition-colors duration-150 hover-text-danger"
                style={{ 
                  gap: 'var(--spacing-sm)', 
                  padding: 'var(--spacing-sm) var(--spacing-md)',
                  color: 'var(--text-secondary)'
                }}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>
    </div>
  )
}
